export { Locales } from '@vimeo/viewer';

export function setLanguage({
  token,
  locale,
}: {
  token: string;
  locale: string;
}): Promise<Response> {
  return fetch('/settings/set_locale', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'content-type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify({
      token,
      locale,
    }),
  });
}
